import React from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';

import styles from './index.module.scss';

export type MaterialEmptyStateType = 'preparing' | 'search';

export interface MaterialEmptyStateProps {
  type: MaterialEmptyStateType;
}

/**
 * 官方资产列表空态，按 Figma 区分普通暂无素材和搜索/筛选无结果。
 */
function MaterialEmptyState({ type = 'preparing' }: MaterialEmptyStateProps): React.ReactElement {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const content = type === 'preparing'
    ? {
      icon: 'fourPointedStarFill',
      title: languageStore.smartcatTranslationText((v) => v.related_materials_are_being_prepared_),
      description: languageStore.smartcatTranslationText(
        (v) => v.this_category_currently_has_no_materials_available_more_content_will_be_opened_soon_please_stay_tuned_,
      ),
    }
    : {
      icon: 'magnifyingGlassBold',
      title: languageStore.smartcatTranslationText((v) => v.no_relevant_material_found),
      description: languageStore.smartcatTranslationText(
        (v) => v.try_using_different_keywords_or_reducing_the_number_of_filters_and_search_again_,
      ),
    };

  return (
    <div className={styles.materialEmptyState}>
      <div className={styles.materialEmptyContent}>
        <div className={styles.materialEmptyIconWrap}>
          <IconFont
            name={content.icon}
            fontSize={20}
            color="var(--content-primary, rgb(247 248 250 / 96%))"
            className={styles.materialEmptyIcon}
          />
        </div>
        <div className={styles.materialEmptyText}>
          <p className={styles.materialEmptyTitle}>{content.title}</p>
          <p className={styles.materialEmptyDescription}>{content.description}</p>
        </div>
      </div>
    </div>
  );
}

export default MaterialEmptyState;
